import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toaster } from "../../utils/utils";
import {
  getProposalValidation,
  untagPolicy,
} from "../../store/actions/proposalActions";

const Untagged = () => {
  const [proposalData, setProposalData] = useState({
    proposal: "",
    error: false,
    reason: "",
    reasonError: false,
    policyNo: "",
  });
  const [isUntagDisable, setIsUntagDisable] = useState(true);
  const [isReasonShow, setIsReasonShow] = useState(false);
  const [validationApiResponse, setValidationApiResponse] = useState({});
  const dispatch = useDispatch();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!proposalData.proposal) {
      setProposalData({ ...proposalData, error: true });
      return;
    }
    const param = {
      newProposalNumber: proposalData.proposal,
    };
    dispatch(
      getProposalValidation(param, (resp) => {
        if (resp.status === "OK") {
          setProposalData({...proposalData, policyNo: resp.body.policyNo, reason: ''});
          setIsUntagDisable(false);
          setIsReasonShow(true);
        } else {
          setIsUntagDisable(true);
          setIsReasonShow(false);
        }
        toaster(resp?.messageType, resp?.message);
        setValidationApiResponse(resp);
      })
    );
    
  };

  const inputHandler = (e, name) => {
    if (name === "proposalno") {
      if(e.target.value === '') {
        setIsUntagDisable(true);
        setIsReasonShow(false);
        setValidationApiResponse({});
      }
      setProposalData({
        ...proposalData,
        proposal: e.target.value,
        error: false,
      });
    } else if (name === "reason") {
      setProposalData({
        ...proposalData,
        reason: e.target.value,
        reasonError: false,
      });
    }
  };

  const handleUntag = (e) => {
    e.preventDefault();
    if (!proposalData.proposal) {
      setProposalData({ ...proposalData, error: true });
      return;
    }
    if (!proposalData.reason) {
      setProposalData({ ...proposalData, reasonError: true });
      return;
    }
    const param = {
      newProposalNumber: proposalData.proposal,
      reason: proposalData.reason,
    };
    dispatch(untagPolicy(param, (resp) => {}));
  };

  return (
    <div className="proposalDetails_comp">
      <form>
        <div className="input-fields-wrapper">
          <input
            onChange={(e) => inputHandler(e, "proposalno")}
            value={proposalData.proposal}
            className={`input-field`}
            type="text"
            placeholder="Enter Proposal Number"
            name="proposal"
          />
        </div>
        {proposalData.error && (
          <div className="error">Please Enter Proposal Number</div>
        )}
        {isReasonShow && (
          <>
            <div className="label mt-4">Policy Number</div>
            <div className="input-fields-wrapper">
              <input
                value={proposalData.policyNo}
                className={`input-field`}
                type="text"
                name="policyNo"
                disabled
              />
            </div>
          </>
        )}
        {validationApiResponse && validationApiResponse?.messageType && (
          <div className={validationApiResponse?.messageType}>
            {validationApiResponse?.message}
          </div>
        )}
        {isReasonShow && (
          <>
            <div className="input-fields-wrapper mt-4">
              <input
                onChange={(e) => inputHandler(e, "reason")}
                value={proposalData.reason}
                className={`input-field`}
                type="text"
                placeholder="Enter Reason here"
                name="reason"
              />
            </div>
            {proposalData.reasonError && (
              <div className="error">Please Enter Reason</div>
            )}
          </>
        )}
        <button className="searchbt" onClick={handleSubmit}>
          Submit
        </button>
        <button
          className={`${isUntagDisable ? "btdisabled" : "searchbt"} ms-2`}
          onClick={handleUntag}
          disabled={isUntagDisable}
        >
          Untag
        </button>
      </form>
    </div>
  );
};

export default Untagged;
